import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";

@Module({namespaced: true})
export default class LanguageModule extends VuexModule {
  private lang: '日本語' | '한국어' | '中文' | 'English' = '日本語';

  @Mutation
  setLanguage(lang: '日本語' | '한국어' | '中文' | 'English') {
    this.lang = lang;
  }

  @Action({ rawError: true })
  setLang(lang: '日本語' | '한국어' | '中文' | 'English') {
    this.context.commit("setLanguage", lang);
  }

  get language() {
    return this.lang;
  }

  get getMenuNameKey(): string {
    let lang = '';
    switch (this.lang) {
    case '日本語': lang = 'ja'; break;
    case '한국어': lang = 'kr'; break;
    case '中文': lang = 'cn'; break;
    case 'English': lang = 'en'; break;

    default: lang = 'ja'; break;
    }

    return lang !== 'ja' ? `name_${lang}` : 'name';
  }

  get getSubMenuNameKey(): string {
    let lang = '';
    switch (this.lang) {
    case '日本語': lang = 'subName'; break;
    case '한국어': lang = 'subNameKr'; break;
    case '中文': lang = 'subNameCn'; break;
    case 'English': lang = 'subNameEn'; break;

    default: lang = 'subName'; break;
    }

    return lang;
  }
}
